module.exports = __webpack_public_path__ + "img/healthy.192fe61a.png";